<script setup>
import Cookies from 'js-cookie'
import { ref, watch } from 'vue'
import useUser from '../../../../Composables/User/useUser.ts'
import useToast from '../../Composables/useToast'
import ModalError from './Modal/ModalError.vue'
import ModalSearch from './Modal/ModalSearch.vue'
import ModalWaitingText from './Modal/ModalWaitingText.vue'
import AsideBar from './Navigation/SideBar/AsideBar.vue'
import Topbar from './Navigation/Topbar/Topbar.vue'
import ToastList from './Toast/ToastList.vue'

const props = defineProps({
  menu: {
    type: String,
    required: false,
    default: null,
  },
  client: {
    type: Boolean,
    default: false,
  },
  sideMenu: {
    type: Boolean,
    default: true,
  },
  topBar: {
    type: Boolean,
    default: true,
  },
})

const { toasts, errors } = useToast()
const { hasRole } = useUser()

const sidebar = ref(null)
const modalErrorHome = ref(null)
const sideMenuExpanded = ref(false)
const sidebarCollapsed = ref(Cookies.get('sidebar_collapsed') === 'true' || false)

const toggleSideMenu = (forceEditSideMenuExpanded = false) => {
  const isDesktop = window.innerWidth > 768

  if (isDesktop && forceEditSideMenuExpanded === false) {
    if (sidebar.value) {
      sidebar.value.toggleSidebar()
      sidebarCollapsed.value = sidebar.value.isCollapsed
    }
  } else {
    if (forceEditSideMenuExpanded && !sideMenuExpanded.value) {
      return
    }

    sideMenuExpanded.value = !sideMenuExpanded.value
  }
}

watch(errors, (newErrors) => {
  if (newErrors.length > 0) {
    console.error('PageLayout detected errors:', newErrors)
    if (modalErrorHome.value) {
      modalErrorHome.value.open()
    }
  } else {
    if (modalErrorHome.value) {
      modalErrorHome.value.close()
    }
  }
})

const handleToggleClick = () => {
  toggleSideMenu(false)
}
</script>
<template>
  <div>
    <div class="page-layout">
      <button class="sidebar-toggle-arrow" @click="handleToggleClick" aria-label="Toggle sidebar">
        <i class="fa fa-chevron-left"></i>
      </button>
      <AsideBar
        v-if="sideMenu"
        ref="sidebar"
        :menu="menu"
        :variant="client ? 'client' : 'default'"
        :expanded="sideMenuExpanded"
        @toggle-side-menu="toggleSideMenu"
      />
      <div class="main-content">
        <Topbar
          v-if="topBar"
          :sidebar-expanded="!sidebarCollapsed"
          :variant="client ? 'client' : 'default'"
          @toggle-side-menu="toggleSideMenu"
        />
        <slot></slot>
      </div>
    </div>
    <div v-if="sideMenuExpanded" class="app-backdrop backdrop-sidebar" @click="toggleSideMenu"></div>
    <ModalWaitingText />
    <ModalSearch v-if="hasRole('ROLE_APP_ADMIN_ENTITY_FULL')"></ModalSearch>
    <ToastList :messages="[...toasts, ...$root.toasts]" />
    <ModalError v-if="errors.length > 0" ref="modalErrorHome" id="modal-error-home" :errors="errors" />
  </div>
</template>
